var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CContainer',[_c('CRow',[_c('CCol',{staticClass:"d-flex overflow-auto px-0",attrs:{"col":"12"}},[_c('CheckoutFilterIt')],1)],1),_c('CheckoutListTable',{staticClass:"mt-2"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }